// Минимальный hash-роутер для SPA-областей (CartApp/ProfileApp).
// Подписка через rxjs.Subject, чтобы можно было observer'ить как сторы.
import { Subject } from 'rxjs';

class HashRouter {
  constructor() {
    this.subject = new Subject();
    this.hash = (typeof window !== 'undefined' && window.location.hash) || '';
    if (typeof window !== 'undefined') {
      window.addEventListener('hashchange', () => {
        this.hash = window.location.hash;
        this.subject.next(this);
      });
    }
  }
  go(h) {
    if (typeof window === 'undefined') return;
    window.location.hash = h;
  }
}

let _r = null;
export const router = (() => {
  if (!_r) _r = new HashRouter();
  return _r;
})();



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/hashRouter.js